module.exports = __webpack_public_path__ + "img/Gold.8928c383.png";